import React from 'react';
import { useInstantSearch } from 'react-instantsearch';

const ClearAll = () => {
    const { setIndexUiState } = useInstantSearch();

    return (
        <a
            onClick={(event) => {
                event.preventDefault();
                setIndexUiState((currentState) => ({
                    ...currentState,
                    query: '',
                    refinementList: {},
                }));
            }}
        >
            Clear All
        </a>
    );
};

export default ClearAll;
